import React, { useEffect } from 'react';

import { YOTPO_RATINGS_INSTANCE_ID } from '../../api/constants';

type Props = {
  productRef: string;
  productName: string;
  reviewsRef?: React.RefObject<HTMLDivElement>;
};

export const YotpoRating = ({ productRef, productName, reviewsRef }: Props) => {
  useEffect(() => {
    (window as any).yotpoWidgetsContainer?.initWidgets();
  }, [productRef]);

  const handleClick = () => {
    reviewsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (!reviewsRef) {
    return (
      <div
        className="yotpo-widget-instance"
        data-yotpo-instance-id={YOTPO_RATINGS_INSTANCE_ID}
        data-yotpo-product-id={productRef}
        data-yotpo-name={productName}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        textAlign: 'left',
        display: 'block',
        width: '100%',
      }}
      aria-label="Voir les avis"
    >
      <div
        className="yotpo-widget-instance"
        data-yotpo-instance-id={YOTPO_RATINGS_INSTANCE_ID}
        data-yotpo-product-id={productRef}
        data-yotpo-name={productName}
      />
    </button>
  );
};
